import { rootReducer } from './reducers';
import { Action, PreloadedState, ThunkAction, configureStore } from '@reduxjs/toolkit';
import { authApi } from '@store/auth';
import { coverageApi } from '@store/coverage';
import { outagesApi } from '@store/outages/outages.api';
import { typeOfBusinessCategoriesApi } from '@store/typeOfBusinessCategories/typeOfBusinessCategories.api';
import { policiesApi } from './policy/policy.api';
import { usTerritoriesApi } from '@store/usTerritories/usTerritories.api';
import { userApi } from '@store/user';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import thunk from 'redux-thunk';

export const setupStore = (preloadedState?: PreloadedState<RootState>) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(
        thunk,
        authApi.middleware,
        userApi.middleware,
        usTerritoriesApi.middleware,
        typeOfBusinessCategoriesApi.middleware,
        policiesApi.middleware,
        outagesApi.middleware,
        coverageApi.middleware,
      ),
  });
};
export const store = setupStore();
export const useTypedDispatch = () => useDispatch<AppDispatch>();
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof rootReducer>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;